export const HOME = "/";
export const WELCOME = "/welcome";
export const SIGNUP = "/signup";
export const SIGNIN = "/signin";
export const LEAVE = "/Leaves";
export const DETECT = "/take-attendance";
export const ENROLL = "/enroll";
export const ABOUT = "/testimonials";
// export const FEATURE = "/feature";
